class ProfileForm {
    static init($context = null) {
        var selector = "[data-profile-form]";
        let $containers = $context ? $context.find(selector) : $(selector);
        var emailFormSelector = "[data-profile-form-type='email']";
        var notificationFormSelector = "[data-profile-form-type='notifications']";

        $containers.each(function (index, element) {
            if ($(element).data('data-profile-form')) return;

            $(element).data('data-profile-form', new ProfileForm(
                $(element).find(emailFormSelector),
                $(element).find(notificationFormSelector)
            ))
        });
    }

    constructor(emailForm, notificationsForm) {
        this.version = '0.0.1'

        this.emailForm = emailForm;
        this.$emailForm = $(emailForm);
        this.notificationsForm = notificationsForm;
        this.$notificationsForm = $(notificationsForm);

        this.emailField = this.$emailForm.find('[name*="attributes"][name*="Email"], [name*="attributes"][name*="email"]');
        this.emailNotificationsField = this.$emailForm.find('[name="notifications"]');
        this.notificationsFields = this.$notificationsForm.find('[name="notifications"]');

        this.onNotificationsFieldsChange();
        this.onNotificationsFormSubmit();
    }

    onNotificationsFieldsChange() {
        this.notificationsFields.on('change', function () {
            const selectedValue = this.$notificationsForm.find('[name="notifications"]:checked').val();
            this.emailNotificationsField.val(selectedValue);

            let emailField = $(this.emailField).closest('.form-group');
            let $label = emailField.find('label');

            if (selectedValue === 'email') {
                let $asterisk = $label.find('i.ph-asterisk');
                if ($asterisk.length === 0) {
                    $label.append(' <i class="ph ph-asterisk"></i>');
                } else {
                    $asterisk.show();
                }
            } else {
                $label.find('i.ph-asterisk').hide();
            }
        }.bind(this));

    }

    onNotificationsFormSubmit() {
        this.$notificationsForm.on('submit', (e) => {
            //Stop cms-ajax-form from submitting
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            this.removeFormFeedbacks(this.$notificationsForm);
            const selectedNotification = this.$notificationsForm.find('[name="notifications"]:checked').val();

            // If notification type is email, validate/submit email form first
            if (selectedNotification === 'email') {
                this.removeFormFeedbacks(this.$emailForm);
                this.submitEmailForm()
                    .done((response) => {
                        if (response.status === 'ok') {
                            this.submitNotificationsForm();
                        } else {
                            this.handleFormErrors(this.$emailForm, response);
                            this.displayMessages(this.$emailForm, response);
                        }
                    })
            } else {
                // If not email notification, submit directly
                this.submitNotificationsForm();
            }
        });
    }

    removeFormFeedbacks($form) {
        $form.find('input,select,textarea')
            .removeClass('is-invalid is-valid')
            .parents('.form-group')
            .removeClass('has-error')
            .find('.invalid-feedback')
            .html('');
    }

    submitEmailForm() {
        return $.ajax({
            url: this.$emailForm.attr('action'),
            type: this.$emailForm.attr('method') || 'POST',
            data: this.$emailForm.serialize(),
            dataType: 'json'
        });
    }

    submitNotificationsForm() {
        return $.ajax({
            url: this.$notificationsForm.attr('action'),
            type: this.$notificationsForm.attr('method') || 'POST',
            data: this.$notificationsForm.serialize(),
            dataType: 'json'
        }).done((response) => {
            if (response.status === 'ok') {
                if (response.redirect) {
                    window.location.href = response.redirect;
                } else if (response.message) {
                    this.displayMessages(this.$notificationsForm, response);
                }
            } else {
                this.handleFormErrors(this.$notificationsForm, response);
                this.displayMessages(this.$notificationsForm, response);
            }
        });
    }

    handleFormErrors($form, response) {
        // Mark fields with errors (similar to cms-ajax-form)
        if (response.errors && typeof response.errors === 'object') {
            for (const fieldName in response.errors) {
                const $field = $form.find(`[name="${fieldName}"]`);

                if ($field.length) {
                    $field.addClass('is-invalid')
                        .closest('.form-group')
                        .addClass('has-error')
                        .find('.invalid-feedback')
                        .html(response.errors[fieldName]);
                }
            }
        }
    }

    displayMessages($form, response) {
        if (!response.message) return;

        let modalBody = '';

        if (typeof response.message === 'object') {
            if (Array.isArray(response.message)) {
                response.message.forEach((msg, index) => {
                    if (typeof msg === 'object') {
                        const iconSrc = `/Project/Modules/General/Admin/assets/images/icons/icon-${msg.type}.svg`;
                        if (index === 0) {
                            modalBody += `<img src="${iconSrc}" alt="${msg.type}"/><h5 class="modal-title">${msg.text}</h5>`;
                        } else {
                            modalBody += `<h5 class="modal-title">${msg.text}</h5>`;
                        }
                    } else {
                        const icon = index === 0 ? '<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg" alt="info"/>' : '';
                        modalBody += `${icon}<h5 class="modal-title">${msg}</h5>`;
                    }
                });
            } else {
                const iconSrc = `/Project/Modules/General/Admin/assets/images/icons/icon-${response.message.type}.svg`;
                modalBody += `<img src="${iconSrc}" alt="${response.message.type}"/><h5 class="modal-title">${response.message.text}</h5>`;
            }
        } else {
            modalBody += `<img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg" alt="info"/><h5 class="modal-title">${response.message}</h5>`;
        }

        if (modalBody) {
            this.displayModal($form, this.getModalHtml(modalBody), response);
        }
    }

    displayModal($form, modalHtml, response) {
        const $modal = $(modalHtml);
        $('body').append($modal);
        const bsModal = new bootstrap.Modal($modal[0], {});

        let redirect = null;
        if (typeof response.redirect === 'string') {
            redirect = response.redirect;
        }

        $modal.on('hidden.bs.modal', () => {
            bsModal.dispose();
            $modal.remove();

            if (redirect) {
                window.location.href = redirect;
            }
        });

        if (typeof response.modal_auto_close === 'number' && response.modal_auto_close > 0) {
            setTimeout(() => {
                bsModal.hide();
            }, response.modal_auto_close);
        }

        bsModal.show();
    }

    getModalHtml(modalBody) {
        return `
        <div class="modal fade modal-ajax-form" tabindex="-1" aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-body">${modalBody}</div>
                    <div class="modal-footer py-3 my-0">
                        <button type="button" class="btn btn-primary close-modal" data-bs-dismiss="modal" aria-label="Close">Uždaryti</button>
                    </div>
                </div>
            </div>
        </div>
    `;
    }
}

if (typeof module === "object" && typeof module.exports === "object"){

    ProfileForm.init()
    //node modules support
    module.exports = ProfileForm;
}else{
    $(function(){
        ProfileForm.init()
    });
}